






















import { Component, Prop, Vue } from 'vue-property-decorator'
import CommonButton from '@/components/common/CommonButton.vue'

@Component({
  components: { CommonButton },
})
export default class BuilderButton extends Vue {
  @Prop({ default: false, type: Boolean }) private disabled!: boolean

  @Prop({ default: false, type: Boolean }) private light!: boolean
}
